import React from 'react';
import { useSelector } from 'react-redux';

import { selectActiveActivity } from '../../redux/classroomSlice';
import { selectContentByActivityId } from '../../redux/contentSlice';
import LoadingSpinner from '../ui/LoadingSpinner';
import '../shared/ActivityComponent.css';

const Librarian = () => {
  const activeActivity = useSelector(selectActiveActivity);
  const activityId = activeActivity?.id;
  const isActive = activeActivity?.leader === 'Librarian';

  const resources = useSelector((state) => selectContentByActivityId(state, activityId));
  const safeResources = Array.isArray(resources) ? resources : [];

  if (!isActive) return null;

  if (!resources) {
    // Not yet prefetched
    return <LoadingSpinner />;
  }

  return (
    <div className="activity-component">
      <div className="activity-header">
        <h2>Library Resources</h2>
      </div>
      <div className="activity-content">
        {safeResources.length > 0 ? (
          <div className="resource-list">
            {safeResources.map((resource, idx) => (
              <div key={idx} className="resource-item">
                <h4>{resource.title || 'Untitled Resource'}</h4>
                {resource.description && <p>{resource.description}</p>}
                {resource.link && (
                  <a href={resource.link} target="_blank" rel="noopener noreferrer">
                    View Resource
                  </a>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="activity-error text-center">
            <p>📝 No study resources available for this activity.</p>
            <p>We&apos;ll keep improving this section as you continue learning!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Librarian;
